<template>
  <div class="pagination">
    <a>共 {{ itemTotal }} 条</a>
    <a @click="validateIndex(0)">首页</a>
    <a @click="validateIndex(pageIndex - 1)" style="font-weight: 500">&lt;</a>
    <a v-for="i in indexShown" :key="i" @click="validateIndex(i - 1)" :class="pageIndex === i - 1 ? 'active' : ''">{{
      i
    }}</a>
    <a @click="validateIndex(pageIndex + 1)" style="font-weight: 500">&gt;</a>
    <a @click="validateIndex(pageTotal)">尾页</a>
    <!-- <span>共{{ pageTotal + 1 }}页</span> -->
    <input
      @keyup.enter="validateIndex(inputIndex - 1)"
      v-model="inputIndex"
      style="width: 30px;text-align: center;margin-left: 18px;"
    />
    <span>/ {{ pageTotal + 1 }} 页</span>
    <!-- <span>每页</span>
    <select v-model="newPageSize" @change="$emit('changesize', newPageSize)">
      <option value="10">10</option>
      <option value="20">20</option>
      <option value="50">50</option>
    </select>
    <span>项</span> -->
  </div>
</template>

<script>
export default {
  name: 'pagination',
  data() {
    return {
      newPageSize: null,
      inputIndex: null,
    };
  },
  props: {
    itemTotal: Number,
    pageIndex: Number,
    pageSize: Number,
  },
  mounted: function() {
    this.newPageSize = this.pageSize;
    this.inputIndex = this.pageIndex + 1;
  },
  computed: {
    pageTotal: function() {
      return Math.ceil(this.itemTotal / this.pageSize) - 1;
    },
    indexShown: function() {
      const maxIndex = Math.ceil(this.itemTotal / this.pageSize);
      const arr = Array(maxIndex)
        .fill()
        .map((_, i) => i + 1);
      if (maxIndex < 6) return arr;

      if (this.pageIndex < 2) {
        return arr.filter(v => Math.abs(3 - v) < 3);
      } else if (this.pageIndex > maxIndex - 3) {
        return arr.filter(v => Math.abs(maxIndex - 2 - v) < 3);
      } else {
        return arr.filter(v => Math.abs(this.pageIndex + 1 - v) < 3);
      }
    },
  },
  methods: {
    validateIndex(index) {
      // window.console.log(index);
      if (parseInt(index) > -1 && parseInt(index) < this.pageTotal + 1) {
        this.$emit('changeindex', parseInt(index));
        this.inputIndex = index + 1;
      }
    },
  },
};
</script>

<style scoped>
a {
  cursor: pointer;
}
select {
  border: none;
  appearance: none;
  font-size: 14px;
  font-weight: 400;
  background: #ffffff;
  cursor: pointer;
}
.pagination {
  margin: 40px 0;
  text-align: center;
  color: #333333;
  font-size: 14px;
}
.pagination a {
  padding: 6px 12px;
  margin: 0px 4px;
  border: 1px solid #eeeeee;
  border-radius: 6px;
}
.pagination span {
  margin: 0px 8px;
}
.pagination .active {
  color: #ffffff;
  background: #5d89c0;
  border-color: #5d89c0;
}
</style>
